var map = {
	"./competa/acoster/image1.jpg": 166,
	"./competa/acoster/image2.jpg": 165,
	"./competa/acoster/image3.jpg": 164,
	"./competa/acoster/thumb.jpg": 163,
	"./competa/brightwave/image1.jpg": 162,
	"./competa/brightwave/image2.jpg": 161,
	"./competa/brightwave/image3.jpg": 160,
	"./competa/brightwave/image4.jpg": 159,
	"./competa/brightwave/test.jpg": 158,
	"./competa/brightwave/thumb.jpg": 157,
	"./mach3builders/fapadag/image1.jpg": 156,
	"./mach3builders/fapadag/image2.jpg": 155,
	"./mach3builders/fapadag/image3.jpg": 154,
	"./mach3builders/fapadag/thumb.jpg": 153,
	"./spilcreative/thefashionprofessor/app/image1.png": 152,
	"./spilcreative/thefashionprofessor/app/image2.jpg": 151,
	"./spilcreative/thefashionprofessor/app/image3.jpg": 150,
	"./spilcreative/thefashionprofessor/app/thumb.png": 149,
	"./spilcreative/thefashionprofessor/website/image1.jpg": 148,
	"./spilcreative/thefashionprofessor/website/image2.jpg": 147,
	"./spilcreative/thefashionprofessor/website/image3.jpg": 146,
	"./spilcreative/thefashionprofessor/website/thumb.jpg": 145,
	"./spilcreative/website/image1.jpg": 144,
	"./spilcreative/website/image2.jpg": 143,
	"./spilcreative/website/image3.jpg": 142,
	"./spilcreative/website/thumb.jpg": 141,
	"./teqplay/shiprating/image1.jpg": 140,
	"./teqplay/shiprating/image2.jpg": 139,
	"./teqplay/shiprating/image3.jpg": 138,
	"./teqplay/shiprating/thumb.jpg": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;